import React from "react";
import { createBrowserRouter } from "react-router-dom";
import Login from "../pages/auth/Login";
import ProtectedRoute, { SuperProtectedRoute } from "./ProtectedRoute";
import ManageEmployer from "../pages/employer/ManageEmployer";
import ManageCandidates from "../pages/candidates/ManageCandidates";
import PublicRoute from "./PublicRoute";
import Chat from "../pages/chat/Chat";
import LandingPages from "../components/Landing-Pages/LandingPages";
import Createform from "../components/CreateFormPage/CreateForm";
import { IAC } from "../components/IAC/IAC";
const AppRouter = createBrowserRouter([
  {
    element: <PublicRoute />,
    children: [
      {
        path: "/",
        element: <Login />,
      },
      {
        path: "/login",
        element: <Login />,
      },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "/manage-employer",
        element: <ManageEmployer />,
      },
      {
        path: "/manage-candidates",
        element: <ManageCandidates />,
      },
      {
        path: "/manage-LandingPages",
        element:<SuperProtectedRoute> <LandingPages /></SuperProtectedRoute>,
      },
      { path: "/create-form/:id?", element:<SuperProtectedRoute> <Createform /></SuperProtectedRoute> },

      {
        path: "/chat/:id",
        element: <Chat />,
      },
      {
        path: "/provision/:id",
        element: <SuperProtectedRoute><IAC /></SuperProtectedRoute>,
      },
    ],
  },
]);

export default AppRouter;
